import React from "react"
import PropTypes from "prop-types"

import { Trans, Link } from "gatsby-plugin-react-i18next"

import ibm from "../images/ibm-partner-plus.svg"

import * as footerStyles from "../styles/Footer.module.css"
import CubewiseLink from "./_base/CubewiseLink"

const flatListToHierarchical = (
  data = [],
  { idKey = "id", parentKey = "parentId", childrenKey = "children" } = {},
) => {
  const tree = []
  const childrenOf = {}
  data.forEach(item => {
    const newItem = { ...item }
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem
    childrenOf[id] = childrenOf[id] || []
    newItem[childrenKey] = childrenOf[id]
    parentId
      ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
      : tree.push(newItem)
  })
  return tree
}

const Footer = props => {
  const { menuItems } = props
  // const hierarchicalMenuItems = flatListToHierarchical(menuItems)

  // TODO: Hack due footer sync issues
  const hierarchicalMenuItems = [
    { label: "Terms and Conditions", path: "/terms-and-conditions" },
    { label: "Privacy Policy", path: "/privacy-policy" },
  ]

  return (
    <>
      <div className={`row ${footerStyles.wrapper}`}>
        <div
          className={`d-none d-lg-flex col-12 col-lg-3 ${footerStyles.copyright}`}
        >
          <p>&copy; Cubewise 2024</p>
          <img src={ibm} alt="IBM" />
        </div>
        <div className={`col-12 col-lg-6 ${footerStyles.linksWrapper}`}>
          <div className={`row ${footerStyles.doGoodWrapper}`}>
            <div className={`col-12 ${footerStyles.doGood}`}>
              <p>#DoGoodTM1</p>
            </div>
          </div>
          <div className={`row ${footerStyles.legalWrapper}`}>
            <div className={`col-12 ${footerStyles.legal}`}>
              {hierarchicalMenuItems.map((item, idx) => (
                <CubewiseLink
                  linkPath={item.path}
                  key={idx}
                  isFile={false}
                  openBlank={false}
                  translate={true}
                  pageContext={props.pageContext}
                  modals={props.modals}
                >
                  <Trans>{item.label}</Trans>
                </CubewiseLink>
              ))}
            </div>
          </div>
        </div>
        <div className={`col-12 col-lg-3 ${footerStyles.socialMedia}`}>
          <a href="https://www.youtube.com/c/Cubewise" className="youtube">
            <i className="bi bi-youtube"></i>
          </a>
          <a href="https://www.linkedin.com/company/cubewise">
            <i className="bi bi-linkedin"></i>
          </a>
        </div>
        <div className={`d-lg-none col-12 col-lg-3 ${footerStyles.copyright}`}>
          <p>&copy; Cubewise 2025</p>
          <img src={ibm} alt="IBM" />
        </div>
      </div>
    </>
  )
}

export default Footer

Footer.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      parentId: PropTypes.string,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      connectedNode: PropTypes.shape({
        node: PropTypes.shape({
          id: PropTypes.string.isRequired,
          excerpt: PropTypes.string,
        }),
      }),
    }).isRequired,
  ).isRequired,
}
